export enum UserCognitoStatus {
  ARCHIVED = 0,
  COMPROMISED = 1,
  CONFIRMED = 2,
  EXTERNAL_PROVIDER = 3,
  FORCE_CHANGE_PASSWORD = 4,
  RESET_REQUIRED = 5,
  UNCONFIRMED = 6,
  UNKNOWN = 7,
}

const userCognitoStatusMap: Record<UserCognitoStatus, string> = {
  [UserCognitoStatus.ARCHIVED]: 'Archived',
  [UserCognitoStatus.COMPROMISED]: 'Compromised',
  [UserCognitoStatus.CONFIRMED]: 'Confirmed',
  [UserCognitoStatus.EXTERNAL_PROVIDER]: 'External Provider',
  [UserCognitoStatus.FORCE_CHANGE_PASSWORD]: 'Force Change Password',
  [UserCognitoStatus.RESET_REQUIRED]: 'Reset Required',
  [UserCognitoStatus.UNCONFIRMED]: 'Unconfirmed',
  [UserCognitoStatus.UNKNOWN]: 'Unknown',
};

export function UserCognitoStatusToString(status: UserCognitoStatus): string {
  return userCognitoStatusMap[status] || 'Unknown';
}
